import * as types from 'src/store/types';
export default {
  refreshUserInfo(state, data) {
    state.id = data.id
    state.groups = data.groups
    state.isActive = data.isActive
    state.isStaff = data.isStaff
    state.isSuperuser = data.isSuperuser
    state.username = data.username
    state.email = data.email
    state.permissions = data.userPermissions
    state.data = data
  }
};
